import { ACCENT, PAPER, illustrationA11y, lineStyle } from './static-art';

export function BrowserPhoneHeartIllustration(props: {
	className?: string;
	label?: string;
	ink?: string;
	paper?: string;
}) {
	const line = lineStyle(props.ink, 1.20625);
	return (
		<svg
			width="193"
			height="193"
			viewBox="0 0 193 193"
			fill="none"
			className={props.className}
			{...illustrationA11y(props.label)}
		>
			<path
				d="M155.915 35.132H21.6059C18.3896 35.132 15.7822 37.7403 15.7822 40.9579V134.25C15.7822 137.467 18.3896 140.076 21.6059 140.076H155.915C159.131 140.076 161.738 137.467 161.738 134.25V40.9579C161.738 37.7403 159.131 35.132 155.915 35.132Z"
				{...line}
			/>
			<path
				d="M170.39 71.3195H134.994C131.777 71.3195 129.17 73.9278 129.17 77.1454V151.137C129.17 154.355 131.777 156.963 134.994 156.963H170.39C173.606 156.963 176.214 154.355 176.214 151.137V77.1454C176.214 73.9278 173.606 71.3195 170.39 71.3195Z"
				fill={props.paper ?? PAPER}
				{...line}
			/>
			<path d="M15.7822 44.782H161.738" {...line} />
			<path d="M129.068 80.8187L176.112 80.8187" {...line} />
			<path d="M53.1768 119.57H124.346" {...line} />
			<path d="M138.719 118.213H167.669" {...line} />
			<path d="M62.8262 124.395H113.489" {...line} />
			<path d="M142.338 123.037H162.844" {...line} />
			<path d="M142.338 113.388H162.844" {...line} />
			<path
				d="M109.893 60.7933C100.886 53.6822 91.7743 62.2401 88.6239 65.7664C87.9772 66.4898 86.8904 66.5281 86.1935 65.8571C76.9798 56.9567 69.2621 59.2639 65.4303 61.4804C63.4786 62.6109 62.0038 64.4385 61.2239 66.6228C57.9983 75.6663 64.9708 86.3259 72.2117 94.2934L76.6593 99.071C80.6842 102.809 84.7959 105.932 86.4773 107.176C87.0699 107.615 87.8633 107.617 88.4617 107.186C109.986 91.6355 121.962 70.3204 109.891 60.7913L109.893 60.7933Z"
				fill={ACCENT}
			/>
		</svg>
	);
}
